module.exports = __webpack_public_path__ + "static/media/chess-queen.c3567b56.svg";